import $ from 'jquery';
import { occoApi } from './occoAPI-module.js';
import { getWatermarkSrc, initAccessDataStorage, makeAccessData } from './accessData.js';
import { redirectToPage } from './page-routes.js';
import { t } from './localization.js';
import { ecomAddLineItems, ecomBuildTipLineItem, ecomHasFullUnlockProduct, ecomHasTipProduct, ecomLoadTipProducts, ecomRenderTipCheckoutPopupHtml } from '../../../packages/src/e-commerce-api/EcommerceUtil.js';

// After doing any changes please keep sync this duplicate files in PHOTOALBUM projects
export const REAL_IMAGE_PATH = process.env.IMG_PATH;
export const DEFAULT_SHOOT_HELP_IMG = 'img/remoteShootingDefaultImage.jpg';
export const OCCO_360_VIEWER_PATH = `${REAL_IMAGE_PATH}/360viewer/`;
export const photoPlusVariantId = localStorage.getItem('shopDigitalVariantId');
const fullUnlockProduct = localStorage.getItem('fullUnlockProduct');

export function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function formatCurrency(currencyCode) {
  if (currencyCode === 'USD') return '$';
  return currencyCode;
}

function formatDecimals(value, digitals = 2) {
  return (Math.round(value * 100) / 100).toFixed(digitals);
}

export function formatPrice({ amount = 0, currencyCode = 'USD' }) {
  return `${formatCurrency(currencyCode)}${formatDecimals(amount)}`;
}

export function getQueryVariable(variable) {
  const query = globalThis.location.search.substring(1);
  const vars = query.split('&');
  for (let i = 0; i < vars.length; i += 1) {
    const pair = vars[i].split('=');
    if (pair[0] === variable) {
      return decodeURI(pair[1]);
    }
  }
  return false;
}

export function showLoading() {
  $('.screenOverlay').show();
  $('#cssload-cupcake').show();
}

export function hideLoading() {
  setTimeout(() => {
    $('#cssload-cupcake').hide();
    $('.screenOverlay').hide();
  }, 100);
}

export const customPopUp = {
  show() {
    $('#customPopUp').modal('show');
  },
  hide() {
    $('#customPopUp').modal('hide');
  },
  html(content) {
    $('#customPopUpBody').html(content || '');
  },
};

export function getParameterByName(name, url) {
  const normalizedName = name.replaceAll(/[\[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${normalizedName}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replaceAll(/\+/g, ' '));
}

export function alertMessagePopup(text) {
  const opt = {
    title: t('info-title'),
    body: text,
  };
  elId('messagePopUpTitle').innerHTML = opt.title ? opt.title : '';
  elId('messagePopUpBody').innerHTML = opt.body ? opt.body : '';
  $('#messagePopUp').modal('show');
}

export function remoteCapture(attId, robotId) {
  showLoading();
  getRobotSettings(robotId, (robotSettings) => {
    hideLoading();
    const RC_TXT1 = robotSettings.RC_TXT1 || t('remote-shoot-start-message');
    const RC_TXT2 = robotSettings.RC_TXT2 || t('remote-shoot-countdown-message');
    const RC_TXT3 = robotSettings.RC_TXT3 || t('remote-shoot-rendering-message');
    const RC_URL1 = robotSettings.RC_URL1 || DEFAULT_SHOOT_HELP_IMG;
    const content = `<div id="shootCont">
        <img src="${RC_URL1}" width="100%" alt="" /><br><br>
        <span class="">${RC_TXT1}</span><br><br>
        <button type='button' id="shootPhoto" class='btn btn-primary btn-circle btn-xl'>${t('remote-shoot-btn')}</button>
        </div><br>`;
    customPopUp.html(content);
    customPopUp.show();
    $('#shootPhoto').on('click', () => {
      const shootContent = `<div id="cDownCont">
            <span class="" id="hpText">${RC_TXT2}</span><br><br>
            <div id ="cDId" class="cDownLabel">3</div> <br>
            <div id ="closeCont">
              <button class="btn btn-primary btn-sh" onclick="backToHomePage()">${t('ok-btn')}</button>
            </div>
            </div><br>`;
      $('#shootCont').html(shootContent);
      $('#closeCont').hide();
      countDown(3, RC_TXT3);
      remoteCaptureReq(attId, robotId);
    });
  });
}

export function uploadFileToS3(file, s3key, s3bucketUrl, s3fields, callbackSuccess) {
  const fd = new FormData();
  fd.append('key', s3key);
  fd.append('acl', 'public-read');
  fd.append('success_action_status', '201');
  let fileType = 'image/jpeg';
  if (file.type && file.type !== '') {
    fileType = file.type;
  }
  fd.append('Content-Type', fileType);
  fd.append('X-Amz-Credential', s3fields['X-Amz-Credential']);
  fd.append('X-Amz-Algorithm', s3fields['X-Amz-Algorithm']);
  fd.append('X-Amz-Date', s3fields['X-Amz-Date']);
  fd.append('X-Amz-Security-Token', s3fields['X-Amz-Security-Token']);
  fd.append('Policy', s3fields.Policy);
  fd.append('X-Amz-Signature', s3fields['X-Amz-Signature']);
  fd.append('file', file);

  const xhr = new XMLHttpRequest();

  xhr.addEventListener(
    'load',
    () => {
      // onSuccess
      let finalPath = `${REAL_IMAGE_PATH}/${s3key}`;
      if (callbackSuccess) {
        if (s3fields.bucket) {
          finalPath = `https://${s3fields.bucket}/${s3key}`;
        }
        callbackSuccess(finalPath);
      }
    },
    false
  );

  xhr.open('POST', s3bucketUrl, true); // MUST BE LAST LINE BEFORE YOU SEND

  xhr.send(fd);
}

export function elId(id) {
  return document.getElementById(id);
}

export function isValidExtension(extension) {
  return /(jpg|jpeg|png|gif|mp4)$/gi.test(extension);
}

export function updateAppParams(visitDate, eventName = null, callback = () => {}) {
  const appInfoObj = {
    uId: getQueryVariable('uId'),
    vDate: visitDate || getQueryVariable('vDate'),
    lat: getQueryVariable('lat'),
    long: getQueryVariable('long'),
    prePaid: getQueryVariable('prePaid'),
    email: getQueryVariable('email'),
    lang: getQueryVariable('lang'),
    eventName,
  };
  $.ajax({
    type: 'POST',
    url: `${process.env.BACKEND_API}/genting-app/add-visit-date-info`,
    data: JSON.stringify({
      app_info_obj: appInfoObj,
    }),
    dataType: 'json',
    success(resp) {
      if (resp?.result) {
        callback(resp.result);
      }
    },
  });
}

export function unlinkImagesReq(selectedPhotoIdArray, deleteReason, eventId, keyType, keyValue, callback) {
  const body = {
    photo_id_array: selectedPhotoIdArray,
    delete_reason: deleteReason,
    event_id: eventId,
    key_type: keyType,
    key_value: keyValue,
  };
  $.ajax({
    type: 'POST',
    url: `${process.env.BACKEND_API}/photo/list/unlink`,
    data: JSON.stringify(body),
    dataType: 'json',
    success(resp) {
      if (resp?.result) {
        callback(null, resp.result);
      }
    },
    error(err) {
      callback(err, null);
    },
  });
}

export function pAttendeeAttachPhotosByQR(attendeeUid, photoUids) {
  return new Promise((resolve) => {
    const body = {
      attendee_uid: attendeeUid,
      photo_uid_array: photoUids,
    };
    $.ajax({
      type: 'POST',
      url: `${process.env.BACKEND_API}/attendee/attach-photos-by-qr-scan`,
      data: JSON.stringify(body),
      dataType: 'json',
      success: resolve,
    });
  });
}

export function attendeeAttachPhotosByQR(attendeeUid, photoUids) {
  showLoading();
  const body = {
    attendee_uid: attendeeUid,
    photo_uid_array: photoUids,
  };
  $.ajax({
    type: 'POST',
    url: `${process.env.BACKEND_API}/attendee/attach-photos-by-qr-scan`,
    data: JSON.stringify(body),
    dataType: 'json',
    success() {
      reloadPage();
    },
  });
}

function reloadPage() {
  globalThis.location.reload();
}

export function get360url(normalImageUrl) {
  return `${OCCO_360_VIEWER_PATH}?url=${normalImageUrl}&closeable=false`;
}

export function backToKioskStoreHome() {
  redirectToPage.index({ rawSearch: '?hfb=true' });
}

export function backToHomePage() {
  globalThis.location.href = localStorage.getItem('home');
}

export function showPaidMessage(checkout, fromHome) {
  const photoPlusAlreadyExist = ecomHasFullUnlockProduct(checkout);
  const isVip = localStorage.getItem('isVip');
  if (!fromHome) {
    if (photoPlusAlreadyExist || isVip === '1') {
      showTipProducts(checkout);
      return;
    }
  } else if (photoPlusAlreadyExist || isVip === '1') {
    return;
  }

  const message = t('checkout-digital-package-upsell-message');
  const content = `<div>
    <h6>${message} </h6><br> <br>
     <button id="maybeLaterBtn" type = "button" class = "btn btn-light btn-lg" data-dismiss = "modal">${t('photo-plus-maybe-later-btn')}</button>
     <button id="buyPhotoPlus" type = "button" class = "btn btn-primary btn-lg">${t('photo-plus-upgrade-btn')}</button></div>`;
  customPopUp.html(content);
  customPopUp.show();
  if (!fromHome) {
    $('#maybeLaterBtn').on('click', () => {
      showTipProducts(checkout);
    });
  }
  $('#buyPhotoPlus').on('click', () => {
    customPopUp.hide();
    buyFullUnlockGlob(checkout);
  });
}

export function alertDigitalPackDuplicationAndRedirect(variant, cart) {
  if (variant.product_purpose === 'full_unlock' && ecomHasFullUnlockProduct(cart)) {
    const lsMessage = localStorage.getItem('shopDigitalProductDupMsg');
    const message = lsMessage || t('checkout-digital-package-duplicate-message');
    const content = `<div>
        <h6>${message} </h6><br> <br>
        <button id="buttonOK" type="button" class="btn btn-primary btn-lg">${t('ok-btn')}</button></div>`;
    customPopUp.html(content);
    customPopUp.show();
    $('#buttonOK').on('click', () => {
      globalThis.location.href = 'shopping-cart.html';
    });
    return true;
  }
  return false;
}

export function alertIfNoEvent(eventName) {
  if (!eventName || eventName === false || eventName === 'false' || eventName === null || eventName === 'null') {
    alert('eventName is not provided.');
    return true;
  }
  return false;
}

export function buyFullUnlockGlob(checkout) {
  const photoPlusAlreadyExist = ecomHasFullUnlockProduct(checkout);
  if (photoPlusAlreadyExist) {
    showTipProducts(checkout);
    return;
  }

  const eventName = localStorage.getItem('eventName');
  // Event name is critical parameter and must be provided correctly
  if (alertIfNoEvent(eventName)) {
    return;
  }

  const lineItems = [];
  const attUid = localStorage.getItem('attUidWA') || getQueryVariable('uId');
  const fullUnlockProd = JSON.parse(fullUnlockProduct);
  const lineItem = {
    variantId: fullUnlockProd.variantId,
    quantity: 1,
  };

  lineItem.customAttributes = [];
  const variantArr = [];
  const newVariant = {};
  newVariant.productTitle = fullUnlockProd.title;
  newVariant.pid = 0;
  newVariant.eventName = eventName;
  newVariant.id = fullUnlockProd.id;
  newVariant.attendeeUid = attUid;
  newVariant.action = 'unlock';
  newVariant.uniqueField = getUUID();
  variantArr.push(newVariant);
  lineItem.customAttributes.push({
    key: '_variantArr',
    value: JSON.stringify(variantArr),
  });
  lineItems.push(lineItem);
  // alert(JSON.stringify(variantArr))
  ecomAddLineItems(checkout.id, lineItems)
    .then((updatedCheckout) => {
      showTipProducts(updatedCheckout);
    })
    .catch((err) => {
      console.error('Error adding to cart:', err);
    });
}

export async function showTipProducts(checkout) {
  const tipProducts = await ecomLoadTipProducts({ channel: 'webapp' });
  if (!Array.isArray(tipProducts) || tipProducts.length === 0 || ecomHasTipProduct(checkout)) {
    openCheckoutPage(checkout);
    return;
  }

  customPopUp.html(
    ecomRenderTipCheckoutPopupHtml({
      tipProducts,
      message: t('checkout-tip-message'),
      description: t('checkout-tip-description'),
      noTipLabel: t('checkout-no-tip-btn'),
    })
  );
  customPopUp.show();

  const disableTipActions = () => {
    $('#noTipBtn, .tip-amount-btn').prop('disabled', true);
  };

  $('#noTipBtn')
    .off('click')
    .on('click', () => {
      disableTipActions();
      customPopUp.hide();
      openCheckoutPage(checkout);
    });

  $('.tip-amount-btn')
    .off('click')
    .on('click', async function onTipClick() {
      disableTipActions();
      const tipProduct = tipProducts.find((tip) => Number(tip.id) === Number(this.dataset.tipId));
      customPopUp.hide();
      if (!tipProduct) {
        openCheckoutPage(checkout);
        return;
      }

      const eventName = localStorage.getItem('eventName');
      if (alertIfNoEvent(eventName)) return;

      try {
        const updatedCheckout = await ecomAddLineItems(checkout.id, [
          ecomBuildTipLineItem(tipProduct, {
            eventName,
            attendeeUid: localStorage.getItem('attUidWA') || getQueryVariable('uId'),
            uniqueField: getUUID(),
          }),
        ]);
        openCheckoutPage(updatedCheckout || checkout);
      } catch (err) {
        console.error('Error adding tip to cart:', err);
        openCheckoutPage(checkout);
      }
    });
}

export function getCustomAttribute(lineItem, customAttName) {
  return lineItem.customAttributes?.find((att) => att.key === customAttName)?.value ?? null;
}

function openCheckoutPage(checkout) {
  localStorage.setItem('pendingCheckoutStartedAt', String(Date.now()));
  globalThis.location = checkout.webUrl || checkout.checkoutUrl;
}

function remoteCaptureReq(attendeeUid, robotId) {
  const body = {
    attendee_uid: attendeeUid,
    aws_robot_name: robotId,
  };
  $.ajax({
    type: 'POST',
    url: `${process.env.BACKEND_API}/attendee/make-a-shoot`,
    data: JSON.stringify(body),
    dataType: 'json',
    success() {},
  });
}

function countDown(number, RC_TXT3) {
  let count = number;
  if (count >= 0) {
    $('#cDId').html(count);
    count -= 1;
    setTimeout(() => {
      countDown(count, RC_TXT3);
    }, 1000);
  } else {
    $('#cDId').html('');
    $('#closeCont').show();
    $('#hpText').html(RC_TXT3);
  }
}

export function trackPhotoEvent({ activityName, photoId, robotId = null, attendeeUid }) {
  const activityType = 'info';
  occoApi.activityCreateByRobotId(robotId, photoId, activityName, activityType, attendeeUid, (err) => {
    if (err) {
      return alertMessagePopup(err.message_key);
    }
  });
}

export function trackListOfPhotoEvent({ activityName, listOfPhotoId, robotId = null, attendeeUid }) {
  const activityType = 'info';
  occoApi.activityBulkCreateByRobotId(robotId, listOfPhotoId, activityName, activityType, attendeeUid, (err) => {
    if (err) {
      return alertMessagePopup(err.message_key);
    }
  });
}

function getRobotSettings(robotId, callback) {
  const body = {
    aws_robot_name: robotId,
  };
  $.ajax({
    type: 'POST',
    url: `${process.env.BACKEND_API}/robot/settings/retrieve`,
    data: JSON.stringify(body),
    dataType: 'json',
    success(resp) {
      let settings = {};
      if (resp?.result?.state) {
        settings = resp.result.state;
      }
      callback(settings);
    },
  });
}

export function fromUrlFilename(url) {
  if (!url) {
    return url;
  }
  return url.split('/').pop();
}

export function isValidEmail(email, multi = false) {
  const emailRegex =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // Email address
  let validEmail = true;
  if (multi) {
    const emails = email.split(',');
    if (emails && emails.length > 1) {
      $.each(emails, (index, value) => {
        if (!emailRegex.test(value)) {
          return false;
        }
      });
    } else {
      validEmail = emailRegex.test(emails[0]);
    }
  } else {
    validEmail = emailRegex.test(email);
  }
  return validEmail;
}

export function showAlert(text) {
  alert(text);
}

/**
 * Shows a blocking error overlay that cannot be dismissed
 * @param {string} message - Error message to display
 */
export function showBlockingError(message) {
  // Remove existing error overlay if present
  const existingOverlay = document.getElementById('blocking-error-overlay');
  if (existingOverlay) {
    existingOverlay.remove();
  }

  // Create blocking overlay
  const overlay = document.createElement('div');
  overlay.id = 'blocking-error-overlay';
  overlay.className = 'blocking-error-overlay';

  const errorBox = document.createElement('div');
  errorBox.className = 'blocking-error-box';

  const errorIcon = document.createElement('div');
  errorIcon.className = 'blocking-error-icon';
  errorIcon.textContent = '⚠️';

  const errorTitle = document.createElement('h3');
  errorTitle.className = 'blocking-error-title';
  errorTitle.textContent = 'Error';

  const errorMessage = document.createElement('p');
  errorMessage.className = 'blocking-error-message';
  errorMessage.textContent = message;

  errorBox.appendChild(errorIcon);
  errorBox.appendChild(errorTitle);
  errorBox.appendChild(errorMessage);
  overlay.appendChild(errorBox);
  document.body.appendChild(overlay);

  // Prevent any interaction with the page
  overlay.addEventListener('click', (e) => e.stopPropagation());
  overlay.addEventListener('contextmenu', (e) => e.preventDefault());
}

// Export function to update QR menu text
export function updateQRMenuText(isShowMode = false) {
  const qrMenuItem = document.querySelector('#openQRreader .menu__item-text');
  if (qrMenuItem) {
    qrMenuItem.textContent = isShowMode ? 'My Album Code' : 'QR Scanner';
  }
}

export async function createAttendee({ eventCode, name, email, phoneNumber }) {
  return new Promise((resolve) => {
    const data = {
      eventCode,
      attendeeName: name,
      attendeeEmail: email,
      attendeePhoneNumber: phoneNumber,
    };
    $.ajax({
      type: 'POST',
      url: `${process.env.BACKEND_API}/attendee/create-and-send-email`,
      data: JSON.stringify(data),
      dataType: 'json',
      success: resolve,
    });
  });
}

export function deleteRestrictionHelpMessage() {
  const content = `<div>${t('checkout-delete-restriction-message')}</div><br>
                     <button  type = "button" class = "btn btn-primary btn-lg" data-dismiss = "modal">${t('ok-btn')}</button>`;
  customPopUp.html(content);
  customPopUp.show();
}

export function prepareTagsFilter(desc) {
  if (!desc || !isJsonString(desc)) return { acceptTags: [], denyTags: [] };
  const params = JSON.parse(desc);
  const acceptTags = params.require_tag || [];
  const denyTags = params.deny_tag || [];
  return { acceptTags, denyTags };
}

export function getProductTagType(product) {
  const prodDesc = product.desc || product.description;
  let prodDescJson = {};
  const resProdTypes = {
    acceptTags: [],
    denyTags: [],
  };
  if (prodDesc) {
    try {
      prodDescJson = JSON.parse(prodDesc);
    } catch (error) {
      console.log(`Wrong JSON format in description: ${prodDesc} error: ${error}`);
      prodDescJson = {};
    }
  }
  let productAcceptTags = [];
  let productDenyTags = [];
  if (prodDescJson.require_tag) {
    productAcceptTags = productAcceptTags.concat(prodDescJson.require_tag);
    resProdTypes.acceptTags = productAcceptTags;
  }
  if (prodDescJson.deny_tag) {
    productDenyTags = productDenyTags.concat(prodDescJson.deny_tag);
    resProdTypes.denyTags = productDenyTags;
  }
  return resProdTypes;
}

export function initThrottle() {
  const throttleData = {};

  // eslint-disable-next-line no-prototype-builtins
  const isEnabled = (key) => throttleData.hasOwnProperty(key) && throttleData[key];
  const disable = (key) => {
    throttleData[key] = false;
  };
  const enable = (key) => {
    throttleData[key] = true;
  };

  const disableOverTime = (key, milliseconds) => setTimeout(() => disable(key), milliseconds);

  return (id, cb, timeout) => {
    if (!isEnabled(id)) {
      cb();
      enable(id);
      disableOverTime(id, timeout);
    }
  };
}

export function isPrintable(variant) {
  return variant?.productPurpose === 'printable' || variant?.product_purpose === 'printable';
}

export function isNonPrintable(variant) {
  return !isPrintable(variant);
}

function isUnlockMedia(variant) {
  return variant?.productPurpose === 'partial_unlock_media' || variant?.product_purpose === 'partial_unlock_media';
}

export function isSelectable(variant) {
  return isPrintable(variant) || isUnlockMedia(variant);
}

export function isNonSelectable(variant) {
  return !isSelectable(variant);
}

export function isValidForPrint(src, tags) {
  return /(jpg|jpeg|png)$/gi.test(fileExt(src)) || (src.includes('uokg5o') && tags.acceptTags.includes('uokg5o'));
}

function fileExt(path) {
  return path.split('.').pop().toLowerCase();
}

export function isValidForPrintAndUnlock(src, tags, unlockMedia) {
  return (
    /(jpg|jpeg|png)$/gi.test(fileExt(src)) ||
    unlockMedia === 'unlock_media' ||
    localStorage.getItem('isUnlockMedia') === 'true' ||
    (src.includes('uokg5o') && tags.acceptTags.includes('uokg5o'))
  );
}

export function isJsonString(str) {
  if (!str || str.trim().length === 0) {
    return false;
  }
  try {
    JSON.parse(str);
  } catch (error) {
    console.log(`Wrong JSON string: ${str} error: ${error}`);
    return false;
  }
  return true;
}

const accessDataStorage = initAccessDataStorage();
accessDataStorage.getData(makeAccessData());

export function preparePhotosForDisplay(photos, tags, unlockMedia) {
  return photos
    .filter(
      (photo) =>
        isValidForPrintAndUnlock(photo.full_path, tags, unlockMedia) &&
        checkProductTagTypeAndImageTag(photo.thumb_full_path, tags)
    )
    .map((photo) => ({ ...photo, watermarkSrc: getWatermarkSrc(accessDataStorage.getData(), photo) }));
}

export function checkProductTagTypeAndImageTag(imgUrl, prodTag) {
  if (
    !prodTag ||
    (!prodTag.acceptTags && !prodTag.denyTags) ||
    (prodTag.acceptTags.length === 0 && prodTag.denyTags.length === 0)
  ) {
    return true;
  }

  let fileName = '';
  if (imgUrl) {
    fileName = fromUrlFilename(imgUrl);
  }

  let isPassedAccept = prodTag.acceptTags.length === 0;
  let isPassedDeny = true;

  for (let i = 0; i < prodTag.acceptTags.length; i += 1) {
    if (fileName.includes(prodTag.acceptTags[i])) {
      isPassedAccept = true;
      break;
    }
  }

  if (isPassedAccept) {
    for (let i = 0; i < prodTag.denyTags.length; i += 1) {
      if (fileName.includes(prodTag.denyTags[i])) {
        isPassedDeny = false;
        break;
      }
    }
  }
  return isPassedAccept && isPassedDeny;
}

export const pluck = (arr, ...keys) =>
  keys.length > 1 ? arr.map((i) => keys.map((k) => i[k])) : arr.map((i) => i[keys[0]]);

export function checkProductTagTypeForAllImages(imgPaths, prodTags) {
  if (
    !prodTags ||
    (!prodTags.acceptTags && !prodTags.denyTags) ||
    (prodTags.acceptTags.length === 0 && prodTags.denyTags.length === 0) ||
    !imgPaths ||
    imgPaths.length === 0
  ) {
    return true;
  }
  let showProduct = false;
  for (const i in imgPaths) { // eslint-disable-line
    showProduct = showProduct || checkProductTagTypeAndImageTag(imgPaths[i], prodTags);
  }
  return showProduct;
}

export function checkProductTagTypeForAllImagesWrapper(variant) {
  return checkProductTagTypeForAllImages(
    pluck(JSON.parse(localStorage.getItem('allPhotos')), 'full_path'),
    prepareTagsFilter(variant.desc)
  );
}

export function checkComboProductsTagTypeForAllImages(combo, alaCarteId, imgPaths) {
  let showComboAfterTagFiltering = !combo.id.includes(alaCarteId);
  const prodTags = {};
  for (const i in combo.products) { // eslint-disable-line
    prodTags.acceptTags = getProductTagType(combo.products[i]).acceptTags;
    prodTags.denyTags = getProductTagType(combo.products[i]).denyTags;
    showComboAfterTagFiltering = combo.id.includes(alaCarteId)
      ? showComboAfterTagFiltering || checkProductTagTypeForAllImages(imgPaths, prodTags)
      : showComboAfterTagFiltering && checkProductTagTypeForAllImages(imgPaths, prodTags);
  }
  return showComboAfterTagFiltering;
}

export function transformIdsToPhotos(ids, photos) {
  return ids.map((photoId) => photos.find((photo) => photo.id === photoId)).filter((photo) => Boolean(photo));
}

export function getCurrentFormModelItem(formModel, currentStep) {
  return formModel[currentStep - 1];
}

export function isAndroid() {
  return /android/i.exec(navigator.userAgent);
}

export function isIPhone() {
  return /(iPad)|(iPhone)|(iPod)/i.exec(navigator.userAgent);
}

export function isMobile() {
  return isAndroid() || isIPhone();
}

export function renameFileNameMutate(file, newName) {
  Object.defineProperty(file, 'name', {
    writable: true,
    value: newName,
    configurable: true,
  });
}
export function getUUID() {
  if (crypto?.randomUUID) {
    return crypto.randomUUID();
  }
  return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
}

const downloadSingleFile = async (url) => {
  const response = await fetch(url);
  const blob = await response.blob();
  const urlAsArray = url.split('/');
  const fileName = urlAsArray[urlAsArray.length - 1];
  const a = document.createElement('a');
  a.download = fileName;
  a.style.display = 'none';
  a.href = URL.createObjectURL(blob);
  a.addEventListener('click', () => {
    setTimeout(() => {
      URL.revokeObjectURL(a.href);
      a.remove();
    }, 1000);
  });
  document.body.append(a);
  a.click();
};

const isShareTooLargeError = (error) => {
  const message = `${error?.message || ''}`.toLowerCase();
  return (
    error?.name === 'DataError' ||
    error?.name === 'NotAllowedError' ||
    error?.name === 'TypeError' ||
    message.includes('too large') ||
    message.includes('share data') ||
    message.includes('payload')
  );
};

export const initMultipleDownload = (waitingNotice) => async (photos, attendeeUid) => {
  const title = t('home-media-share-title');

  // Track download events for each photo
  const photoIdList = photos.map((photo) => photo.id);
  trackListOfPhotoEvent({ activityName: 'Download', listOfPhotoId: photoIdList, attendeeUid });

  const downloadFiles = async (urls) => {
    waitingNotice.text(t('home-download-waiting-message'));
    waitingNotice.show();

    try {
      if (isIPhone()) {
        // Check sharing capability before downloading
        if (!navigator.canShare) {
          alert(t('home-share-files-unsupported-message'));
          waitingNotice.hide();
          return;
        }

        // iOS handling using navigator.share
        const files = await Promise.all(
          urls.map(async (url) => {
            const response = await fetch(url);
            const blob = await response.blob();
            const urlAsArray = url.split('/');
            const fileName = urlAsArray[urlAsArray.length - 1];
            return new File([blob], fileName, { type: blob.type });
          })
        );

        await navigator.share({
          files,
          title,
        });
      } else {
        // Android and other devices handling
        await Promise.all(urls.map(downloadSingleFile));
      }
    } catch (error) {
      // Silently ignore user cancellation, log only actual errors
      const userCanceled = error?.name === 'AbortError' || error?.message === 'Share canceled';
      if (userCanceled) {
        return;
      }

      if (isShareTooLargeError(error)) {
        alert(t('download-selection-too-large-message'));
        return;
      }
    } finally {
      waitingNotice.hide();
    }
  };

  await downloadFiles(photos.map((photo) => photo.full_path));
};
